export class PersistStorage {
    getValue(key) {
        try {
            const value = window.localStorage.getItem(key);
            if (value) {
                try {
                    return JSON.parse(value);
                }
                catch (err) {
                    return value;
                }
            }
            return value;
        }
        catch (err) {
            console.log(err);
            // have to implement error handler
        }
    }
    /**
     * saving the value in a key value form
     * @param key key name
     * @param value value corresponding to key name, value should be a string in case of object it should be a stringfy
     */
    setValue(key, value) {
        try {
            window.localStorage.setItem(key, value);
            return true;
        }
        catch (err) {
            console.log(err);
            return;
            // have to implement error handler
        }
    }
    removeValue(key) {
        try {
            window.localStorage.removeItem(key);
            return true;
        }
        catch (e) {
            return;
        }
    }
}
